export interface SubdomainInfo {
  citySlug: string;
  stateUf: string;
}

export function getSubdomainInfo(): SubdomainInfo | null {
  const match = window.location.hostname.match(
    /^(?<city>[^.]+)\.(?<state>[^.]+)\.geoz\.com\.br$/,
  );
  if (match?.groups) {
    return {
      citySlug: match.groups.city.toLowerCase(),
      stateUf: match.groups.state.toUpperCase(),
    };
  }
  return null;
}
